<template>
  <div>
    <h3>Add Opportunity</h3>
    <opportunity-form :categories="categories"
                      :types="types"
                      :terms="terms"
                      :academicPlans="academicPlans"
                      :areaOfInterestCategories="areaOfInterestCategories"
                      :additionalMaterials="additionalMaterials"
                      :applicationTypes="applicationTypes"
                      :opportunity="opportunity"
                      :dirty="dirty"
                      @save="saveOpportunity"
                      ></opportunity-form>
  </div>
</template>

<script>
import OpportunityForm from "../../components/opportunities/opportunity-form";
import opportunitiesApi from "../../api/opportunity";
import sitesApi from "../../api/sites";
import termsApi from "../../api/terms";
import collegeApi from "../../api/college";
import areasOfInterestApi from "../../api/areasOfInterest";
import additionalMaterialsApi from "../../api/additionalMaterials";
import applicationTypesApi from "../../api/applicationTypes";

import Vue from "vue";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  name: "AddOpportunity",
  data() {
    return {
      categories: [],
      types: [],
      terms: [],
      academicPlans: [],
      areaOfInterestCategories: [],
      additionalMaterials: [],
      applicationTypes: [],
      opportunity: {},
      dirty: false
    };
  },

  components: {
    "opportunity-form": OpportunityForm
  },

  computed: {
    opportunityType: function() {
      return this.$store.state.opportunityForm.opportunityType;
    }
  },

  methods: {
    saveOpportunity: function(step) {
      var that = this;
      this.dirty = true;

      // nextTick is needed here to wait for components to set any validations as $error
      Vue.nextTick().then(function() {
        var error = that.$store.getters.hasError;
        if (!error) {
          var opportunity = that.$store.state.opportunityForm.opportunity;

          // remove any additional materials that are no longer valid
          _.forEach(opportunity.opportunityAdditionalMaterials, function(
            opportunityAdditionalMaterial
          ) {
            var additionalMaterial = _.find(that.additionalMaterials, function(
              material
            ) {
              return (
                material.additionalMaterialTypeId ===
                opportunityAdditionalMaterial.additionalMaterialTypeId
              );
            });
            var foundMatch = _.find(
              additionalMaterial.additionalMaterialTypeOpportunityTypeOpportunityCategories,
              function(
                additionalMaterialTypeOpportunityTypeOpportunityCategory
              ) {
                return (
                  additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityCategoryId ===
                    opportunity.opportunityCategoryId &&
                  additionalMaterialTypeOpportunityTypeOpportunityCategory.opportunityTypeId ===
                    opportunity.opportunityTypeId
                );
              }
            );
            if (!foundMatch) {
              opportunity.opportunityAdditionalMaterials = _.reject(
                opportunity.opportunityAdditionalMaterials,
                function(material) {
                  return (
                    material.additionalMaterialTypeId ===
                    opportunityAdditionalMaterial.additionalMaterialTypeId
                  );
                }
              );
            }
          });

          // if translational team is selected, make sure 'How to Apply' is cleared out
          if (that.opportunityType.name == "Translational Team") {
            opportunity.opportunityApplicationTypes = [];
          }

          opportunitiesApi
            .postOpportunity(opportunity)
            .then(function(response) {
              // Toastr Message
              toastr.options = ToastrSettings;
              toastr.success("The opportunity has been saved.", "Success");

              // redirect
              that.$router.push({
                name: "opportunityEdit",
                params: { opportunityId: response.data },
                query: { step: step + 1 }
              });
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    }
  },

  created() {
    var that = this;

    this.$store.commit("resetForm");

    if (this.$route.query.siteId) {
      sitesApi.getSite(this.$route.query.siteId).then(response => {
        that.opportunity = {
          siteId: response.data.siteId,
          site: {
            siteId: response.data.siteId,
            name: response.data.name
          }
        };

        that.$store.commit("updateSiteContacts", response.data.siteContacts);
      });
    }

    opportunitiesApi
      .getOpportunityCategories()
      .then(function(response) {
        that.categories = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    opportunitiesApi
      .getOpportunityTypes()
      .then(function(response) {
        that.types = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    termsApi
      .getCurrentAndFutureTerms()
      .then(function(response) {
        that.terms = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    collegeApi
      .getAcademicPlans()
      .then(function(response) {
        that.academicPlans = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    areasOfInterestApi
      .getAreaOfInterestCategories()
      .then(function(response) {
        that.areaOfInterestCategories = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    additionalMaterialsApi
      .getAdditionalMaterialTypes()
      .then(function(response) {
        that.additionalMaterials = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    applicationTypesApi
      .getApplicationTypes()
      .then(function(response) {
        that.applicationTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
